module.exports = __webpack_public_path__ + "img/mcen3@2x.57258ada.png";